export const Name = 'skip_password_setup';
